/* eslint-disable @typescript-eslint/unbound-method */
// eslint-disable-next-line import/no-extraneous-dependencies
import { alertAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, cssVar } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(
    alertAnatomy.keys
);

const $fg = cssVar('alert-fg');
const $bg = cssVar('alert-bg');

const baseStyle = definePartsStyle({
    container: {
        bg: $bg.reference,
        px: '4',
        py: '4',
    },
    title: {
        fontWeight: 'bold',
        lineHeight: '6',
        marginEnd: '2',
        marginBottom: '0.1em',
    },
    description: {
        fontSize: 'sm',
        color: 'muted.500',
        lineHeight: 'unset',
    },
    icon: {
        color: $fg.reference,
        flexShrink: 0,
        marginEnd: '3',
        w: '5',
        h: '6',
    },
    spinner: {
        color: $fg.reference,
        flexShrink: 0,
        marginEnd: '3',
        w: '5',
        h: '5',
    },
});

const variantSolid = definePartsStyle((props) => {
    const { colorScheme: c } = props;
    return {
        container: {
            rounded: 'md',
            boxShadow: 'sm',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: `${c}.100`,
            bg: `${c}.25`,
            borderLeftWidth: '5px',
            [$fg.variable]: `colors.${c}.500`,
            [$bg.variable]: 'white',
            _dark: {
                [$fg.variable]: 'colors.gray.900',
                [$bg.variable]: `colors.${c}.200`,
            },
            color: $fg.reference,
        },
    };
});

const variants = {
    solid: variantSolid,
};

export const alertTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: 'solid',
        colorScheme: 'blue',
    },
});
